module.exports = __webpack_public_path__ + "static/media/minus-square-white.44033560.svg";